import { SET_VIDEOS } from "../actions/videosActions";

const initState = [];

export const uiReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_VIDEOS:
      return [...action.payload];

    default:
      return state;
  }
};

export default uiReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/videosReducer.js